export const environment = {
  production: false,
  adminPassword: 'dev',
  tokenAuth: 'D25A6dsv6kcdwGYMwMGM',
  urlApp: 'https://dev.bolar.app/',
  // Muestra la hora programada del partido en el tablero de control y en el
  // tablero público. Desactivar cuando el torneo no sigue una agenda estricta.
  showMatchScheduledTime: true,
  firebase: {
    projectId: 'bolar-app-dev',
    appId: '1:375679740568:web:49065c1aba24c8498edef8',
    storageBucket: 'bolar-app-dev.firebasestorage.app',
    apiKey: 'AIzaSyBztYrJvAWjGb2IwaVVaZD-QFd6t3Jhnt8',
    authDomain: 'bolar-app-dev.firebaseapp.com',
    messagingSenderId: '375679740568',
    measurementId: ''
  }
};